import React, {useImperativeHandle, forwardRef} from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Typography from '@mui/material/Typography';

const MUIModal = (props: any, ref: any): any => {
    const [open, setOpen] = React.useState(false);
    const {heading, Icon, component, headingStyle} = props;

    const modalOpen = (): any => {
        setOpen(true);
    };

    const modalClose = (): any => {
        setOpen(false);
    };

    useImperativeHandle(ref, () => ({
        // handleClickOpen: handleClickOpen
        modalOpen,
        modalClose
    }));

    return (
        <Box className="modal-main">
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={open}
                onClose={modalClose}
                closeAfterTransition
                // BackdropComponent={Backdrop}
                // BackdropProps={{
                //     timeout: 500
                // }}
            >
                <Fade in={open}>
                    <Box className="modal-box">
                        <Box className="close-icon">{Icon}</Box>
                        <Box className="modal-header">
                            <Typography id="transition-modal-title" variant="h6" fontWeight={600} component="h6" className={headingStyle}>
                                {heading}
                            </Typography>
                        </Box>
                        <Box className="modal-content">{component}</Box>
                    </Box>
                </Fade>
            </Modal>
        </Box>
    );
};

export default forwardRef(MUIModal);
